import Vue from "vue/dist/vue.min"
import VueNumeric from 'vue-numeric'


Vue.use(VueNumeric)

if ($('#send-money-wrapper').length > 0) {
    new Vue({
        el: '#send-money-wrapper',
        data: {
            under_maintanance: false,
            notice_message_fr:"L’envoi d’argent vers Airtel n’est pas disponible pour le moment.",
            notice_message:"Sending money to Airtel is unavailable at the moment.",
            has_notice_message: false,
            yole_charge: 0.105,
            phone_code:"243",
            currency: 'USD',
            amount: '',
            phone_number: '',
            recipient_country: 'CD',
            address: 'NAS Apartment, Milimani Rd, Nairobi',
            order_tracking_id: '',
            iframe_url: "",
            awaiting_payment: false,
        },
        computed:{
            charge: function () {
                return this.amount ? (Math.round((this.total - this.amount) * 100)/100): null;
            },
            total: function () {
                return this.amount ? (Math.round(this.amount * (1 + this.yole_charge) * 100)/100): null;
            }
        },
        methods: {
            getUser:function () {
                axios.get('/user').then(function (response) {
                    console.log("response",response);
                }).catch(function (error) {
                    console.log("error",error);
                })
            },
            sendMoney: function () {
                let vm = this;
                axios.post('/send-money', {
                    amount: vm.total,
                    sending_amount: vm.amount,
                    phone_number: `${vm.phone_code}${vm.phone_number}`,
                    currency: vm.currency,
                    address: vm.address,
                    recipient_country:vm.recipient_country
                }).then(function (response) {
                    vm.iframe_url = response.data.redirect_url;
                    vm.order_tracking_id = response.data.order_tracking_id;
                    vm.awaiting_payment = true;
                    console.log("aw", vm.awaiting_payment);
                    // vm.checkTransferStatus();
                }).catch(function (error) {
                    if (error.response) {
                        // The request was made and the server responded with a status code
                        // that falls out of the range of 2xx
                        //console.log(error.response.data);
                        // console.log(error.response.status);
                        // console.log(error.response.headers);
                        toastr.error(error.response.data.message, 'Error');
                    } else if (error.request) {
                        // The request was made but no response was received
                        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                        // http.ClientRequest in node.js
                        toastr.error("There was an error processing your transaction", 'Error');
                        //console.log(error.request);
                    } else {
                        // Something happened in setting up the request that triggered an Error
                        toastr.error("There was an error processing your transaction", 'Error');
                        //console.log('Error', error.message);
                    }
                    //console.log(error.config);
                });
            },
            checkTransferStatus() {
                let vm = this;
                axios('/check-transfer-status?id=' + this.transfer_id)
                    .then(function (response) {
                        if (response.data.transfer_status === 'completed') {
                            toastr.success(response.data.message, 'Success');
                            setTimeout(function () {
                                window.location.reload();
                            }, 10000);
                        } else if (response.data.transfer_status === 'expired') {
                            toastr.error(response.data.message, 'Error');
                            setTimeout(function () {
                                window.location.reload();
                            }, 5000);
                        } else if (response.data.transfer_status === 'error') {
                            toastr.error(response.data.message, 'Error');
                            setTimeout(function () {
                                window.location.reload();
                            }, 5000);
                        }
                    }).catch(function (error) {
                    setTimeout(function () {
                        vm.checkTransferStatus();
                    }, 2000);
                });
            }
        },
        watch:{
            recipient_country: function (value) {
                if(value === 'KE'){
                    this.phone_code = '254';
                } else if(value === 'CD'){
                    this.phone_code = '243';
                } else if(value === 'BI'){
                    this.phone_code = '257';
                } else {
                    this.phone_code = '';
                }
            },
            phone_number: function (value) {
                if(value){
                    if(value.startsWith('243') || value.startsWith('254') || value.startsWith('257')){
                        this.phone_number =  value.replace(/^(243|254|257)/, '');
                        toastr.info('Input phone number without country code', 'Info');
                    }
                }
            }
        },
        mounted: function () {
            let vm = this;
            axios.get('/yole-charges').then(function (response) {
                vm.yole_charge = response.data.charges;
            }).catch(function (error) {
                console.log("error",error);
            })
        }

    });
}

if ($('#validate-kyc').length > 0) {
    new Vue({
        el: '#validate-kyc',
        data: {
            phone_code: document.getElementById('phone_code').value,
            phone: document.getElementById('phone_old').value,
            phone_number: document.getElementById('phone_code').value + document.getElementById('phone_old').value,
            otp_retries: 0
        },
        methods: {
            sendOTP() {
                let vm = this;
                axios.post('/kyc/send-otp', {
                    phone: vm.phone_number,
                    phone_code: vm.phone_code
                }).then(function (response) {
                    toastr.success(response.data.message, 'Success');
                }).catch(function (error) {
                    if (error.response) {
                        // The request was made and the server responded with a status code
                        // that falls out of the range of 2xx
                        //console.log(error.response.data);
                        // console.log(error.response.status);
                        // console.log(error.response.headers);
                        toastr.error(error.response.data.message, 'Error');
                    } else if (error.request) {
                        // The request was made but no response was received
                        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                        // http.ClientRequest in node.js
                        toastr.error("The OTP could not be sent at the moment, please try again later.", 'Error');
                        //console.log(error.request);
                    } else {
                        // Something happened in setting up the request that triggered an Error
                        toastr.error("The OTP could not be sent at the moment, please try again later.", 'Error');
                        //console.log('Error', error.message);
                    }
                    //console.log(error.config);
                });
            }
        },
        watch: {
            phone: function (val) {
                this.phone_number = this.phone_code + val;
            }
        }
    });

}

if ($('#withdraw-money-wrapper').length > 0) {
    new Vue({
        el: '#withdraw-money-wrapper',
        data: {
            currency: 'KES',
            amount: '',
            phone_number: '',
            phone_code: '254',
            confirm_withdraw_interval: null,
            transaction_id: ''
        },
        methods: {
            withdrawMoney: function (event) {
                let vm = this;
                let phone_number = "254" + vm.phone_number;
                const regex = /^(?:254|\+254|0)?((7(?:(?:[129][0-9])|(?:0[0-8])|(?:[9][0-9])|(?:[6][8-9])|(?:[5][7-9])|(4([0-6]|[8-9]))))|(11[0-1]))[0-9]{6}$/gm;

                if (vm.amount && regex.exec(phone_number)) {
                    Swal.fire({
                        title: 'Are you sure?',
                        text: "You are about to withdraw KES " + vm.amount + " to 254" + vm.phone_number,
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#198754',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Proceed to Withdraw',
                    }).then((result) => {
                        if (result.isConfirmed) {
                            axios.post('/withdraw-money', {
                                phone: phone_number,
                                amount: vm.amount
                            }).then(function (response) {
                                toastr.success(response.data.message, 'Success');
                                vm.phone_number = '';
                                vm.amount = '';
                                vm.transaction_id = response.data.transaction_id;
                                vm.checkWithdrawalStatus();
                            }).catch(function (error) {
                                if (error.response) {
                                    // The request was made and the server responded with a status code
                                    // that falls out of the range of 2xx
                                    //console.log(error.response.data);
                                    // console.log(error.response.status);
                                    // console.log(error.response.headers);
                                    toastr.error(error.response.data.message, 'Error');
                                } else if (error.request) {
                                    // The request was made but no response was received
                                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                                    // http.ClientRequest in node.js
                                    toastr.error("The withdrawal could not be processed at the moment, please try again later.", 'Error');
                                    //console.log(error.request);
                                } else {
                                    // Something happened in setting up the request that triggered an Error
                                    toastr.error("The withdrawal could not be processed at the moment, please try again later.", 'Error');
                                    //console.log('Error', error.message);
                                }
                                //console.log(error.config);
                            });
                        }
                    })
                } else {
                    toastr.error("Enter the correct amount and phone number", 'Error');
                }
            },
            checkWithdrawalStatus() {
                let vm = this;
                axios('/check-withdrawal-status?id=' + this.transaction_id)
                    .then(function (response) {
                        toastr.success(response.data.message, 'Success');
                        setTimeout(function () {
                            window.location.reload();
                        }, 10000);
                    }).catch(function (error) {
                    setTimeout(function () {
                        vm.checkWithdrawalStatus();
                    }, 2000);
                });
            }
        }
    });

}
